import React, { useState, useImperativeHandle, forwardRef } from "react";
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip';
import '../../styles/main.css';
import { useStyles } from "./StylesCx";
import { useTranslation } from '../hx/useTranslation';

const CxPaper = forwardRef((props, ref) => {
  const classes = useStyles(props);
  const [{ trans }] = useTranslation();

  const { 
    elevation = 2,
    square = false,
    variant = 'elevation',
    responseText,
    style = {},
    children,
    ...rest 
  } = props;

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(rest.visible === 'false' ? false : true);
  const [copied, setCopied] = useState(false);

  useImperativeHandle(props.xref, () => ({
    getType,
    isVisible,
    setVisible,
    setLoading,
    isLoading,
  }));

  const isVisible = () => visible;
  const isLoading = () => loading;
  const getType = () => 'CxPaper';

  const handleCopyToClipboard = () => {
    if (responseText) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = responseText;
      const text = tempElement.innerText;
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    }
  };

  return (
    <Paper
      id='div_CxPaper'
      elevation={elevation}
      square={square}
      variant={variant}
      className={classes.paperRoot}
      style={{ 
        display: visible ? 'block' : 'none', 
        padding: '0', 
        margin: '1rem 0',
        //backgroundColor: '#fafafa',
        width: '100%',
        minHeight: '60px',
        textAlign: 'left',
        position: 'relative', // necesario para posicionar el botón
        ...style 
      }}
      {...rest}
    >
      {/* Botón de copiar arriba a la derecha */}
      {responseText && (
        <Tooltip title={copied ? trans('field.copied_to_x', 'field.clipboard') : trans('field.copy')}>
          <IconButton
            size="small"
            onClick={handleCopyToClipboard}
            style={{
              position: 'absolute',
              top: '0.5rem',
              right: '0.5rem',
              backgroundColor: '#fff',
              boxShadow: '0 0 3px rgba(0,0,0,0.2)',
              zIndex: 10,
            }}
          >
            <FileCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      {/* Spinner de carga */}
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '1rem 0'
          }}
        >
          <CircularProgress color="primary" size={30} />
        </div>
      )}

      {/* Mostrar respuesta renderizando HTML */}
      {responseText && (
        <div
          style={{
            margin: 0,
            padding: '6px',
          }}
          dangerouslySetInnerHTML={{ __html: responseText }}
        />
      )}

      
    </Paper>
  );
});

export default CxPaper;
